var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyfiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office_1",
    "data-name": "office 1",
    transform: "translate(-0.349 -0.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "office_1_Background_Mask_",
    "data-name": "office 1 (Background/Mask)",
    d: "M0,0H23V23H0Z",
    transform: "translate(0.349 0.349)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.472.644A.959.959,0,0,0,7.573,0H2.84A2.848,2.848,0,0,0,0,2.84V4.733H6.238l2.7-2.7Z",
    transform: "translate(1.883 2.83)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M10.81,0,7.3,3.512a.977.977,0,0,1-.672.275H0v7.573A2.848,2.848,0,0,0,2.84,14.2H16.092a2.848,2.848,0,0,0,2.84-2.84V2.84A2.848,2.848,0,0,0,16.092,0H10.81Z",
    transform: "translate(1.883 5.67)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyfiles);
export default __webpack_public_path__ + "static/media/myfiles.0383be4604db1b49aa94263f486e51a0.svg";
export { ForwardRef as ReactComponent };